"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.POGrid = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var collectionsRef_1 = require("common/db/collectionsRef");
var budgetLinesList_1 = require("common/global/budgetLinesList");
var currenciesList_1 = require("common/global/currenciesList");
var donorsList_1 = require("common/global/donorsList");
var projectsList_1 = require("common/global/projectsList");
var unitsList_1 = require("common/global/unitsList");
var usersList_1 = require("common/global/usersList");
var warehousesList_1 = require("common/global/warehousesList");
var useCurrenciesOptions_1 = __importDefault(require("common/hooks/useCurrenciesOptions"));
var lodash_1 = require("lodash");
var emptyCell_1 = require("portal/components/Grid/helpers/emptyCell");
var valueCell_1 = require("portal/components/Grid/helpers/valueCell");
var getDateForCell_1 = __importDefault(require("portal/utils/getDateForCell"));
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var Grid_1 = require("../../../components/Grid/Grid");
var titleCell_1 = require("../../../components/Grid/helpers/titleCell");
var valueByMode_1 = require("../../../components/Grid/helpers/valueByMode");
var header_1 = require("../../../components/header");
var OrderHeader_1 = __importDefault(require("../components/OrderHeader"));
var IRGrid_1 = require("../IR/IRGrid");
function POGrid(_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8;
    var state = _a.state, mode = _a.mode, dispatch = _a.dispatch;
    // const hasSignature = globalProjectsData[state.POData.projectId].hasSignature ?? false
    var hasSignature = false;
    var t = (0, react_i18next_1.useTranslation)().t;
    // const projectCode = globalProjectsData[state.POData.projectId]?.code
    var projectsCodes = state.POData.projectsIds
        .map(function (projectId) { var _a; return (_a = projectsList_1.globalProjectsData[projectId !== null && projectId !== void 0 ? projectId : ""]) === null || _a === void 0 ? void 0 : _a.code; })
        .join(", ");
    var warehouseName = (_c = (_b = warehousesList_1.globalWarehousesData[state.POData.deliverToWarehouseId]) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : "";
    var POBody = [
        [
            (0, titleCell_1.TitleCell)({ title: t("po.PODate") }),
            (_d = (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: mode === "view"
                    ? t("common.date", {
                        date: (0, getDateForCell_1.default)(state === null || state === void 0 ? void 0 : state.POData.PODate, mode),
                    })
                    : (0, getDateForCell_1.default)(state === null || state === void 0 ? void 0 : state.POData.PODate, mode),
                inputType: "datePicker",
                path: "POData.PODate",
                colSpan: 2,
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            })) !== null && _d !== void 0 ? _d : null,
            (0, titleCell_1.TitleCell)({ title: t("po.poNo") }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_f = (_e = state.POData) === null || _e === void 0 ? void 0 : _e.PONumber) !== null && _f !== void 0 ? _f : "",
                inputType: "text",
                path: "POData.PONumber",
                colSpan: 2,
            }),
            (0, titleCell_1.TitleCell)({ title: t("po.projectCode") }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: projectsCodes !== null && projectsCodes !== void 0 ? projectsCodes : "",
                inputType: "text",
                colSpan: 2,
            }),
            (0, titleCell_1.TitleCell)({ title: t("po.correspondingIrCbaNo") }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_g = state.POData.CBANumber) !== null && _g !== void 0 ? _g : "",
                inputType: "text",
                colSpan: 2,
            }),
        ],
        [
            (0, titleCell_1.TitleCell)({ title: "Organization / المنظمة", colSpan: 2 }),
            (0, valueByMode_1.ValueByMode)({
                mode: "view",
                value: "Independent Doctors Association / منظمة الأطباء المستقلين",
                inputType: "text",
                colSpan: 4,
            }),
            (0, titleCell_1.TitleCell)({ title: "Company Name: اسم الشركة", colSpan: 2 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_j = (_h = state.POData) === null || _h === void 0 ? void 0 : _h.supplierName) !== null && _j !== void 0 ? _j : "",
                inputType: "text",
                path: "POData.address",
                colSpan: 4,
            }),
        ],
        [
            (0, titleCell_1.TitleCell)({ title: "Address: العنوان", colSpan: 2 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_k = state.POData.idaAddress) !== null && _k !== void 0 ? _k : "",
                inputType: "text",
                path: "POData.address",
                colSpan: 4,
            }),
            (0, titleCell_1.TitleCell)({ title: "Address: العنوان", colSpan: 2 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_m = (_l = state.POData) === null || _l === void 0 ? void 0 : _l.supplierAddress) !== null && _m !== void 0 ? _m : "",
                inputType: "text",
                path: "POData.address",
                colSpan: 4,
            }),
        ],
        [
            (0, titleCell_1.TitleCell)({ title: "Representative: ممثل", colSpan: 2 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: "Elif Şahin",
                inputType: "text",
                path: "POData.address",
                colSpan: 4,
            }),
            (0, titleCell_1.TitleCell)({ title: "Representative: ممثل", colSpan: 2 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_p = (_o = state.POData) === null || _o === void 0 ? void 0 : _o.supplierContactPerson) !== null && _p !== void 0 ? _p : "",
                inputType: "text",
                path: "POData.address",
                colSpan: 4,
            }),
        ],
        [
            (0, titleCell_1.TitleCell)({ title: "Tel:  تلفون	", colSpan: 2 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: "905523248837",
                inputType: "text",
                colSpan: 4,
            }),
            (0, titleCell_1.TitleCell)({ title: "Tel:  تلفون	", colSpan: 2 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_r = (_q = state.POData) === null || _q === void 0 ? void 0 : _q.supplierPhoneNumber) !== null && _r !== void 0 ? _r : "",
                inputType: "text",
                path: "POData.supplierPhoneNumber",
                colSpan: 4,
            }),
        ],
        [
            (0, titleCell_1.TitleCell)({ title: "Website: موقع", colSpan: 2 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: "https://ida-org.com/en/	",
                inputType: "text",
                colSpan: 4,
            }),
            (0, titleCell_1.TitleCell)({ title: "Website: موقع", colSpan: 2 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_t = (_s = state.POData) === null || _s === void 0 ? void 0 : _s.supplierWebsite) !== null && _t !== void 0 ? _t : "",
                inputType: "text",
                path: "POData.supplierWebsite",
                colSpan: 4,
            }),
        ],
        [
            (0, titleCell_1.TitleCell)({ title: "Email: بريد إلكتروني ", colSpan: 2 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_v = (_u = state.POData) === null || _u === void 0 ? void 0 : _u.idaEmail) !== null && _v !== void 0 ? _v : "",
                inputType: "text",
                colSpan: 4,
            }),
            (0, titleCell_1.TitleCell)({ title: "Email: بريد إلكتروني ", colSpan: 2 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_x = (_w = state.RFQData) === null || _w === void 0 ? void 0 : _w.supplierEmail) !== null && _x !== void 0 ? _x : "",
                inputType: "text",
                path: "POData.supplierWebsite",
                colSpan: 4,
            }),
        ],
        [
            (0, titleCell_1.TitleCell)({ title: "Warehouse Location: موقع المستودع", colSpan: 2 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_z = warehousesList_1.globalWarehousesData[(_y = state.POData) === null || _y === void 0 ? void 0 : _y.deliverToWarehouseId].name) !== null && _z !== void 0 ? _z : "",
                inputType: "text",
                colSpan: 4,
            }),
            (0, titleCell_1.TitleCell)({ title: "Delivery Schedule: تاريخ التوصيل ", colSpan: 2 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_1 = (_0 = state.RFQData) === null || _0 === void 0 ? void 0 : _0.deliveryDate) !== null && _1 !== void 0 ? _1 : "",
                inputType: "text",
                path: "RFQData?.deliveryDate",
                colSpan: 4,
            }),
        ],
        [
            (0, titleCell_1.TitleCell)({ title: "Payment Preferences: طريقة الدفع", colSpan: 2 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: state.RFQData.byBank == "yes"
                    ? "by bank"
                    : state.RFQData.byCash == "yes"
                        ? "by cash"
                        : "-",
                inputType: "text",
                colSpan: 4,
            }),
            (0, titleCell_1.TitleCell)({ title: "Payment Terms:", colSpan: 2 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_3 = (_2 = state.RFQData) === null || _2 === void 0 ? void 0 : _2.deliveryTerms) !== null && _3 !== void 0 ? _3 : "",
                inputType: "text",
                path: "RFQData?.deliveryDate",
                colSpan: 4,
            }),
        ],
        [
            (0, titleCell_1.TitleCell)({ title: "Invoice to: الفواتير ل:", colSpan: 2 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: "Independent Doctors Association / منظمة الأطباء المستقلين",
                inputType: "text",
                colSpan: 4,
            }),
            (0, titleCell_1.TitleCell)({ title: "Delivery Facility: مركز الإستلام", colSpan: 2 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: (_5 = (_4 = state.RFQData) === null || _4 === void 0 ? void 0 : _4.deliveryPlace) !== null && _5 !== void 0 ? _5 : "",
                inputType: "text",
                path: "RFQData?.deliveryDate",
                colSpan: 4,
            }),
        ],
    ];
    var itemsHeader = [
        (0, titleCell_1.TitleCell)({ title: t("po.itemNo"), rowSpan: 2 }),
        (0, titleCell_1.TitleCell)({ title: t("po.budgetLine"), rowSpan: 2 }),
        (0, titleCell_1.TitleCell)({ title: t("po.itemDescription"), colSpan: 2, rowSpan: 2 }),
        (0, titleCell_1.TitleCell)({ title: "Offered Item Description", colSpan: 4, rowSpan: 1 }),
        (0, titleCell_1.TitleCell)({ title: t("po.unit"), rowSpan: 2 }),
        (0, titleCell_1.TitleCell)({ title: t("po.quantity"), rowSpan: 2 }),
        (0, titleCell_1.TitleCell)({ title: t("po.unitPrice"), rowSpan: 2 }),
        (0, titleCell_1.TitleCell)({ title: t("po.subTotal"), colSpan: 1, rowSpan: 2 }),
    ];
    var items = state.POItems.map(function (item, idx) {
        var _a, _b, _c, _d, _e, _f;
        var unit = (_b = (_a = unitsList_1.globalUnitsData[item.unitId]) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : "";
        // const budgetLine = globalBudgetLinesData[item.budgetLineId]?.code;
        var budgetLines = item.budgetLinesIds
            .map(function (budgetLineId) { var _a; return (_a = budgetLinesList_1.globalBudgetLinesData[budgetLineId !== null && budgetLineId !== void 0 ? budgetLineId : ""]) === null || _a === void 0 ? void 0 : _a.code; })
            .join(", ");
        var product = item === null || item === void 0 ? void 0 : item.orderedItem;
        return [
            (0, valueByMode_1.ValueByMode)({ mode: mode, value: idx + 1 + "", inputType: "text" }),
            (0, valueByMode_1.ValueByMode)({ mode: mode, value: budgetLines, inputType: "text" }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: "".concat((_c = product === null || product === void 0 ? void 0 : product.name) !== null && _c !== void 0 ? _c : item === null || item === void 0 ? void 0 : item.productName, "-").concat((_d = product === null || product === void 0 ? void 0 : product.description) !== null && _d !== void 0 ? _d : item === null || item === void 0 ? void 0 : item.productDescription),
                viewValue: "".concat((_e = product === null || product === void 0 ? void 0 : product.name) !== null && _e !== void 0 ? _e : item === null || item === void 0 ? void 0 : item.offeredItem).concat((_f = product === null || product === void 0 ? void 0 : product.description) !== null && _f !== void 0 ? _f : ""),
                inputType: "productSelect",
                path: "POItems[".concat(idx, "].orderedItem"),
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
                colSpan: 2,
            }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: item.offeredItem,
                inputType: "text",
                colSpan: 1,
            }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: item.originCountry,
                inputType: "text",
                colSpan: 1,
            }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: item.warranty,
                inputType: "text",
                colSpan: 1,
            }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: item.expiryDate,
                inputType: "text",
                colSpan: 1,
            }),
            (0, valueByMode_1.ValueByMode)({ mode: mode, value: unit, inputType: "text" }),
            (0, valueByMode_1.ValueByMode)({ mode: mode, value: item.quantity, inputType: "text" }),
            (0, valueByMode_1.ValueByMode)({ mode: mode, value: item.unitPrice, inputType: "text" }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: item.totalPrice.toFixed(2),
                inputType: "text",
                colSpan: 1,
            }),
        ];
    });
    var itemsTotal = (0, lodash_1.sumBy)(state.POItems, function (i) { return i.totalPrice; });
    var overallTotal = itemsTotal +
        (state.POData.shippingCosts === "included" ||
            state.POData.shippingCosts === ""
            ? 0
            : state.POData.shippingCosts) +
        (state.POData.taxes === "included" || state.POData.taxes === ""
            ? 0
            : state.POData.taxes);
    var currenciesOptions = (0, useCurrenciesOptions_1.default)();
    var totalSection = [
        [
            (0, valueByMode_1.ValueByMode)({
                mode: "view",
                value: "IMPORTANT: By Signing and stamping this PO, IDA will accept all purchase terms and conditions specified by the supplier. Any difference or change of this Purchase Order terms and conditions will affect the final processing in both accepting the goods or payments completion. ",
                inputType: "text",
                colSpan: 9,
                rowSpan: 5,
            }),
            (0, titleCell_1.TitleCell)({ title: t("po.total"), colSpan: 2 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: itemsTotal.toFixed(2),
                inputType: "text",
                colSpan: 1,
            }),
        ],
        [
            (0, titleCell_1.TitleCell)({ title: "VAT", colSpan: 2 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: state.POData.taxes === 0 ? "included" : state.POData.taxes,
                path: "POData.taxes",
                inputType: "text",
                colSpan: 1,
            }),
        ],
        [
            (0, titleCell_1.TitleCell)({ title: t("po.shippingCostInsurance"), colSpan: 2 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: state.POData.shippingCosts === 0
                    ? "included"
                    : state.POData.shippingCosts,
                path: "POData.shippingCosts",
                inputType: "text",
                colSpan: 1,
            }),
        ],
        [
            (0, titleCell_1.TitleCell)({ title: t("po.currency"), colSpan: 2 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: state === null || state === void 0 ? void 0 : state.POData.currencyId,
                viewValue: (_6 = currenciesList_1.globalCurrenciesData[state === null || state === void 0 ? void 0 : state.POData.currencyId]) === null || _6 === void 0 ? void 0 : _6.name,
                inputType: "select",
                selectData: currenciesOptions,
                path: "POData.currencyId",
                required: state.triedSubmitting,
                triedSubmitting: state.triedSubmitting,
            }),
        ],
        [
            (0, titleCell_1.TitleCell)({ title: t("po.overallTotal"), colSpan: 2 }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: overallTotal.toFixed(2),
                inputType: "text",
                colSpan: 1,
                path: "POData.overallTotal",
            }),
        ],
    ];
    var approvalCell = function (approvalType, requiredApprovalType) {
        var _a, _b;
        var projectId = state.POData.projectId;
        var overallTotalInDollar = overallTotal / state.RFQData.exchangeRate;
        // const approvalPermissions = hasProjectPermissionWithMinAndMax(
        //   projectId,
        //   [`PO${approvalType}Approval`],
        //   overallTotalInDollar
        // );
        var approvalPermissions = true;
        var approval = (_a = state.approvalsData) === null || _a === void 0 ? void 0 : _a.find(function (e) {
            return e.approvalType === approvalType;
        });
        var requiredApproval = (_b = state.approvalsData) === null || _b === void 0 ? void 0 : _b.find(function (e) {
            return e.approvalType === requiredApprovalType;
        });
        var commonConditions = state.POData.status !== "approved" &&
            state.POData.status !== "cancelled" &&
            state.POData.status !== "completed" &&
            state.POData.status !== "draft" &&
            state.POData.status !== "singedAndArchived";
        if (approval) {
            return (0, valueByMode_1.ValueByMode)({
                mode: "view",
                value: "",
                colSpan: 3,
                rowSpan: 2,
            });
        }
        else if ((approvalPermissions && requiredApproval && commonConditions) ||
            (approvalPermissions && !requiredApprovalType && commonConditions)) {
            return {
                action: "Approve",
                // payload: approvalType,
                payload: {
                    approvedAt: state.approvedAtSignatureDate.toDate(),
                    approvalType: approvalType,
                },
                text: t("cba.approve"),
                confirmMessage: t("alerts.areYouSureYouWantToApproveThisDocument"),
                confirmAction: true,
                type: "button",
                colSpan: 3,
                rowSpan: 2,
            };
        }
        else {
            return (0, emptyCell_1.emptyCell)({
                colSpan: 3,
                rowSpan: 2,
            });
        }
    };
    var getApproval = function (approvalType) {
        var _a;
        var approval = (_a = state.approvalsData) === null || _a === void 0 ? void 0 : _a.find(function (e) {
            return e.approvalType === approvalType;
        });
        return approval;
    };
    var approvingDate = function (approvalType) {
        var approval2 = getApproval(approvalType);
        var date = approval2 === null || approval2 === void 0 ? void 0 : approval2.approvedAt;
        return t("common.date", { date: date === null || date === void 0 ? void 0 : date.toDate() });
    };
    var approvingSig = function (approvalType) {
        var approval2 = getApproval(approvalType);
        var sig = approval2 === null || approval2 === void 0 ? void 0 : approval2.signatureURL;
        return sig;
    };
    function approvals(state, t) {
        var _a;
        var sigMode = function (type) {
            var _a;
            var approval = (_a = state === null || state === void 0 ? void 0 : state.approvalsData) === null || _a === void 0 ? void 0 : _a.find(function (approval) { return approval.approvalType == type; });
            var newMode = mode == "edit" ? "view" : approval ? "view" : "edit";
            return newMode;
        };
        return [
            [
                (0, titleCell_1.TitleCell)({ title: "Approved by Finance ", colSpan: 6, rowSpan: 1 }),
                !getApproval("deputyGeneralDirector") &&
                    state.POData.status === "approved"
                    ? null
                    : (0, titleCell_1.TitleCell)({
                        title: "Approved by Operations Head",
                        colSpan: 6,
                        rowSpan: 1,
                    }),
            ],
            [
                (0, titleCell_1.TitleCell)({ title: t("cba.date"), colSpan: 3, rowSpan: 1 }),
                (0, titleCell_1.TitleCell)({ title: t("cba.signName"), colSpan: 3, rowSpan: 1 }),
                !getApproval("deputyGeneralDirector") &&
                    state.POData.status === "approved"
                    ? null
                    : (0, titleCell_1.TitleCell)({ title: t("cba.date"), colSpan: 3, rowSpan: 1 }),
                !getApproval("deputyGeneralDirector") &&
                    state.POData.status === "approved"
                    ? null
                    : (0, titleCell_1.TitleCell)({ title: t("cba.signName"), colSpan: 3, rowSpan: 1 }),
            ],
            [
                (0, valueByMode_1.ValueByMode)({
                    mode: sigMode("financeProjectsManager"),
                    value: sigMode("financeProjectsManager") === "view"
                        ? approvingDate("financeProjectsManager")
                        : state.approvedAtSignatureDate,
                    inputType: "datePicker",
                    path: "approvedAtSignatureDate",
                    required: state.triedSubmitting,
                    triedSubmitting: state.triedSubmitting,
                    colSpan: 3,
                    rowSpan: 2,
                }),
                // ValueCell({
                //   value: approvingDate("financeProjectsManager"),
                //   colSpan: 3,
                //   rowSpan: 2,
                // }),
                approvalCell("financeProjectsManager"),
                !getApproval("deputyGeneralDirector") &&
                    state.POData.status === "approved"
                    ? null
                    : getApproval("financeProjectsManager")
                        ? (0, valueByMode_1.ValueByMode)({
                            mode: sigMode("deputyGeneralDirector"),
                            value: sigMode("deputyGeneralDirector") === "view"
                                ? approvingDate("deputyGeneralDirector")
                                : state.approvedAtSignatureDate,
                            inputType: "datePicker",
                            path: "approvedAtSignatureDate",
                            required: state.triedSubmitting,
                            triedSubmitting: state.triedSubmitting,
                            colSpan: 3,
                            rowSpan: 2,
                        })
                        : (0, emptyCell_1.emptyCell)({ colSpan: 3, rowSpan: 2 }),
                //   ValueCell({
                //       value: approvingDate("deputyGeneralDirector"),
                //       colSpan: 3,
                //       rowSpan: 2,
                //     }),
                !getApproval("deputyGeneralDirector") &&
                    state.POData.status === "approved"
                    ? null
                    : approvalCell("deputyGeneralDirector", "financeProjectsManager"),
            ],
            [],
            [
                (0, valueCell_1.ValueCell)({
                    value: " ",
                    img: hasSignature && approvingSig("financeProjectsManager"),
                    colSpan: 6,
                    rowSpan: 1,
                }),
                (0, valueCell_1.ValueCell)({
                    value: " ",
                    img: hasSignature && approvingSig("deputyGeneralDirector"),
                    colSpan: 6,
                    rowSpan: 1,
                }),
            ],
            [],
            [
                (0, titleCell_1.TitleCell)({ title: "Approved by Program ", colSpan: 6, rowSpan: 1 }),
                !getApproval("generalDirector") && state.POData.status === "approved"
                    ? (0, valueCell_1.ValueCell)({ value: " ", colSpan: 6, rowSpan: 1 })
                    : (0, titleCell_1.TitleCell)({
                        title: "Approved by General Director",
                        colSpan: 6,
                        rowSpan: 1,
                    }),
            ],
            [
                (0, titleCell_1.TitleCell)({ title: t("cba.date"), colSpan: 3, rowSpan: 1 }),
                (0, titleCell_1.TitleCell)({ title: t("cba.signName"), colSpan: 3, rowSpan: 1 }),
                !getApproval("generalDirector") && state.POData.status === "approved"
                    ? null
                    : (0, titleCell_1.TitleCell)({ title: t("cba.date"), colSpan: 3, rowSpan: 1 }),
                !getApproval("generalDirector") && state.POData.status === "approved"
                    ? null
                    : (0, titleCell_1.TitleCell)({ title: t("cba.signName"), colSpan: 3, rowSpan: 1 }),
            ],
            [
                (0, valueByMode_1.ValueByMode)({
                    value: "",
                    path: "POData.requestedAt",
                    inputType: "text",
                    colSpan: 3,
                    rowSpan: 2,
                    mode: mode,
                }),
                (0, valueByMode_1.ValueByMode)({
                    mode: mode,
                    value: "",
                    path: "POData.requestedBy",
                    inputType: "text",
                    colSpan: 3,
                    rowSpan: 2,
                }),
                !getApproval("generalDirector") && state.POData.status === "approved"
                    ? null
                    : getApproval("deputyGeneralDirector")
                        ? (0, valueByMode_1.ValueByMode)({
                            mode: sigMode("generalDirector"),
                            value: sigMode("generalDirector") === "view"
                                ? approvingDate("generalDirector")
                                : state.approvedAtSignatureDate,
                            inputType: "datePicker",
                            path: "approvedAtSignatureDate",
                            required: state.triedSubmitting,
                            triedSubmitting: state.triedSubmitting,
                            colSpan: 3,
                            rowSpan: 2,
                        })
                        : (0, emptyCell_1.emptyCell)({ colSpan: 3, rowSpan: 2 }),
                //   ValueCell({
                //       value: approvingDate("generalDirector"),
                //       colSpan: 3,
                //       rowSpan: 2,
                //     }),
                !getApproval("generalDirector") && state.POData.status === "approved"
                    ? null
                    : approvalCell("generalDirector", "deputyGeneralDirector"),
            ],
            [],
            [
                (0, valueCell_1.ValueCell)({
                    value: " ",
                    img: hasSignature && ((_a = usersList_1.globalUsersData[state.requestedBy]) === null || _a === void 0 ? void 0 : _a.signatureURL),
                    colSpan: 6,
                    rowSpan: 1,
                }),
                (0, valueCell_1.ValueCell)({
                    value: " ",
                    img: hasSignature && approvingSig("generalDirector"),
                    colSpan: 6,
                    rowSpan: 1,
                }),
            ],
        ];
    }
    var footer = [
        [(0, titleCell_1.TitleCell)({ title: "Vendor approval", colSpan: 12 })],
        [
            (0, titleCell_1.TitleCell)({ title: "Date / تاريخ ", colSpan: 3 }),
            (0, titleCell_1.TitleCell)({ title: "Vendor name / إسم المزود", colSpan: 3 }),
            (0, titleCell_1.TitleCell)({ title: "Stamp / الختم", colSpan: 3 }),
            (0, titleCell_1.TitleCell)({ title: "Signature / التوقيع", colSpan: 3 }),
        ],
        [
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: "",
                colSpan: 3,
                rowSpan: 3,
            }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: "",
                colSpan: 3,
                rowSpan: 3,
            }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: "",
                colSpan: 3,
                rowSpan: 3,
            }),
            (0, valueByMode_1.ValueByMode)({
                mode: mode,
                value: "",
                colSpan: 3,
                rowSpan: 3,
            }),
        ],
    ];
    var donorId = (_7 = projectsList_1.globalProjectsData[state.projectId]) === null || _7 === void 0 ? void 0 : _7.donorId;
    var miLogo = __assign(__assign({}, header_1.baseCell), { type: "image", src: (_8 = donorsList_1.globalDonorsData[donorId]) === null || _8 === void 0 ? void 0 : _8.logo, height: 50, colSpan: 4, textAlign: "center" });
    var gridData = {
        data: __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([
            (0, IRGrid_1.logoHeader)({
                projectId: state.POData.projectId,
                idaLogo: miLogo,
                title: t("po.purchaseOrderPo"),
                colSpan: 4,
            })
        ], POBody, true), [
            itemsHeader,
            [
                (0, titleCell_1.TitleCell)({ title: t("rfq.brand"), colSpan: 1 }),
                (0, titleCell_1.TitleCell)({ title: t("rfq.originCountry"), colSpan: 1 }),
                (0, titleCell_1.TitleCell)({ title: t("rfq.warranty"), colSpan: 1 }),
                (0, titleCell_1.TitleCell)({ title: t("rfq.expiryDate"), colSpan: 1 }),
            ]
        ], false), items, true), totalSection, true), approvals(state, t), true), footer, true),
    };
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(OrderHeader_1.default, { state: __assign({}, state.POData), dispatch: dispatch, type: "PO", orderRef: collectionsRef_1.POsRef.doc(state.POId) }), (0, jsx_runtime_1.jsx)("div", __assign({ style: { backgroundColor: "#fff" } }, { children: (0, jsx_runtime_1.jsx)(Grid_1.ExcelLikeGrid, { onButtonClicked: function (action, payload) {
                        dispatch({
                            type: "buttonClick",
                            data: {
                                action: action,
                                payload: payload,
                            },
                        });
                    }, onValueUpdate: function (path, newValue) {
                        dispatch({
                            type: "update",
                            payload: {
                                path: path,
                                newValue: newValue,
                            },
                        });
                    }, grid: gridData }) }))] }));
}
exports.POGrid = POGrid;
